export default __webpack_public_path__ + "static/media/2019-clorimex.cd712140.png";